import script from "./ClickableCalcStatChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ClickableCalcStatChip.vue?vue&type=script&setup=true&lang=js"

import "./ClickableCalcStatChip.vue?vue&type=style&index=0&id=9a96abc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a96abc4"]])

export default __exports__